import { useDispatch, useSelector } from "react-redux"
import {
  Box,
  CardMedia,
  Dialog,
  DialogContent,
  Grid,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import { AddShoppingCart } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab"
import { DEFAULT_PRODUCT_IMAGE } from "src/app/constants"
import useAddToCart from "src/app/hooks/useAddToCart"
import {
  setActiveProduct,
  setActiveProductQuantity,
} from "src/features/checkout/checkoutSlice"
import DialogTitle from "../common/DialogTitle"

export default function ActiveProductDialog() {
  const dispatch = useDispatch()
  const theme = useTheme()
  const styles = {
    cardMedia: {
      paddingTop: "56.25%", // 16:9
      backgroundSize: "contain",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      [theme.breakpoints.down("md")]: {
        padding: 0,
      },
    },
  }
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))
  const product = useSelector((state) => state.checkout.activeProduct)
  const quantity = useSelector((state) => state.checkout.activeProductQuantity)
  const [addToCart, { isLoading }] = useAddToCart()

  const onClose = () => dispatch(setActiveProduct(null))

  if (!product) return <></>

  return (
    <Dialog
      open={Boolean(product)}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth={"md"}
    >
      <DialogTitle onClose={onClose}>{product.title}</DialogTitle>
      <DialogContent id="active-product-content" dividers>
        <Grid container spacing={fullScreen ? 0 : 3} sx={styles.paper}>
          <Grid item xs={12} sm={6} style={{ alignSelf: "center" }}>
            <CardMedia
              sx={styles.cardMedia}
              image={product.images.edges[0]?.node.url || DEFAULT_PRODUCT_IMAGE}
              title={product.images.edges[0]?.node.altText || ""}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <div
              id="transition-modal-description"
              dangerouslySetInnerHTML={{
                __html: product.descriptionHtml,
              }}
            />
            <Box my={2}>
              <TextField
                id="outlined-number"
                label="Quantity"
                type="number"
                size="small"
                variant="outlined"
                inputProps={{ min: 1 }}
                defaultValue={1}
                onChange={(e) =>
                  dispatch(setActiveProductQuantity(e.target.valueAsNumber))
                }
              />
            </Box>
            <LoadingButton
              loading={isLoading}
              color="primary"
              size="large"
              startIcon={<AddShoppingCart />}
              style={{ width: "100%" }}
              variant="contained"
              onClick={() => addToCart(product, quantity)}
            >
              Add to Cart
            </LoadingButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
